<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        :fullscreen="true"
        class="create_dialog"
    >
      <template #title>
        <div class="title_dialog">
          <span>Sửa phiếu khảo sát</span>
        </div>
      </template>
      <div class="body_dialog">
        <div class="survey_form">

          <!--    Ảnh mở đầu phiếu    -->
          <section class="wrap_image_form radius border">
            <el-image class="main_image" :src="defaultDataForm.imgWeb"/>
            <el-upload
                ref="uploadImageSurveyForm"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                file-list="listImageForm"
                class="upload_image_form"
                :limit="1"
                accept="image/*"
                :show-file-list="true"
                :on-change="handleUploadImage"
                :class="{ hideUpload: listImageForm.length > 0 }"
            >
              <i
                  class="el-icon-plus"
              />

              <template #file="scope">
                <div class="container_image">
                  <img
                      class="el-upload-list__item-thumbnail"
                      :src="scope.file.url" alt="Ảnh"
                  >

                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(scope.file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>

                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemoveImage(scope.file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
              </span>
                </div>
              </template>
            </el-upload>
          </section>

          <!--    Phần tiêu đề và mô tả phiếu    -->
          <section class="header_survey_form radius border element_form">
            <el-input
                type="text"
                placeholder="Tiêu đề phiếu khảo sát"
                v-model="defaultDataForm.title"
                :maxlength="100"
                :show-word-limit="true"
                class="header_survey_title"
                @blur="handleChangeInputHeader()"
            />

            <el-input
                type="textarea"
                placeholder="Mô tả phiếu khảo sát"
                v-model="defaultDataForm.description"
                :maxlength="500"
                :show-word-limit="true"
                :autosize="{minRows: 3, maxRows: 6}"
                :rows="3"
                class="header_survey_description"
            />
          </section>

          <!--    Phần câu hỏi phiếu    -->
          <section class="wrap_question" ref="wrapQuestion">
            <div
                class="radius border element_form"
                v-for="(question, index) in defaultDataForm.questionResponseList"
                :key="index"
                :ref="`elementForm-${index}`"
                @click="handleElementClick(index)"
            >
              <div class="element_body">
                <el-row type="flex" :gutter="14">
                  <el-col :span="14">
                    <div class="element_question">
                      <el-input
                          type="text"
                          placeholder="Câu hỏi"
                          v-model="question.questionText"
                          :maxlength="100"
                          :show-word-limit="true"
                          @blur="(event) => handleChangeTitleQuestion(index, event.target.value)"
                      />

                      <!--   Với câu hỏi văn bản   -->
                      <el-input
                          v-if="question.typeQuestion === 'Text'"
                          type="textarea"
                          placeholder="Văn bản trả lời"
                          :maxlength="500"
                          :show-word-limit="true"
                          :rows="3"
                          :disabled="true"
                          :autosize="{minRows: 3, maxRows: 6}"
                      />

                      <!-- Với câu hỏi hộp kiểm (checkbox) -->
                      <div
                          v-if="question.typeQuestion === 'CheckBox'"
                          class="wrap_checkbox"
                      >
                        <el-checkbox
                            :disabled="true"
                            v-for="(item, indexOption) in question.valueQuestionArray"
                            :label="item.value"
                            :key="indexOption"
                            class="container_checkbox"
                        >
                          <div style="display: inline-block">
                            <el-input
                                type="text"
                                placeholder="Tuỳ chọn"
                                v-model="item.value"
                                :maxlength="100"
                                :show-word-limit="true"
                                style="width: 100%"
                                class="checkbox_options"
                                @blur="(event) => handleChangeValueQuestion(index, indexOption, event.target.value)"
                            />
                          </div>
                          <div
                              v-if="question.valueQuestionArray.length > 1"
                              style="display: inline-block; margin-left: 30px; font-size: 16px; color: #000; cursor: pointer;">
                            <i class="el-icon-close"
                               @click="handleRemoveOptions(question.valueQuestionArray, indexOption)"/>
                          </div>
                        </el-checkbox>
                        <template>
                          <div
                              class="add_option"
                              @click="handleFocusAddOptions(question.valueQuestionArray, `inputAddOptions-${index}`)"
                          >
                            <i class="el-icon-circle-plus"/>
                            <span style="font-weight: 900">Thêm</span>
                          </div>
                        </template>
                      </div>

                      <!--                      Với câu hỏi trắc nghiệm (radio)-->
                      <div
                          v-if="question.typeQuestion === 'Radio'"
                          class="wrap_checkbox"
                      >
                        <el-radio
                            :disabled="true"
                            v-for="(item, index) in question.valueQuestionArray"
                            :label="item.value"
                            :key="index"
                            class="container_checkbox"
                        >
                          <div style="display: inline-block">
                            <el-input
                                type="text"
                                placeholder="Tuỳ chọn"
                                v-model="item.value"
                                :maxlength="100"
                                :show-word-limit="true"
                                style="width: 100%"
                                class="checkbox_options"
                            />
                          </div>
                          <div

                              style="display: inline-block; margin-left: 30px; font-size: 16px; color: #000; cursor: pointer;">
                            <i class="el-icon-close" @click="handleRemoveOptions(question.valueQuestionArray, index)"/>
                          </div>
                        </el-radio>
                        <template>
                          <div
                              class="add_option"
                              @click="handleFocusAddOptions(question.valueQuestionArray, `inputAddOptions-${index}`)"
                          >
                            <i class="el-icon-circle-plus"/>
                            <span style="font-weight: 900">Thêm</span>
                          </div>
                        </template>
                      </div>

                      <!--   Với câu hỏi chọn điểm   -->
                      <div v-if="question.typeQuestion === 'Point'">
                        <el-row type="flex">
                          <el-col
                              v-for="(item, index) in 10"
                              :span="2"
                              :key="index"
                          >
                            <div
                                style="
                              display: flex;
                              justify-content: center">
                            <span
                                class="option_point"
                            >
                              {{ item }}
                            </span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <!--   Với câu hỏi đánh giá (Sao)   -->
                      <div v-if="question.typeQuestion === 'Star'">
                        <div style="display: flex; gap: 0 10px">
                        <span v-for="item in 5" :key="item" class="icon_star">
                          <i class="el-icon-star-off"/>
                        </span>
                        </div>
                      </div>
                    </div>
                  </el-col>

                  <el-col :span="10">
                    <div style="display: flex; justify-content: end">
                      <el-select
                          v-model="question.typeQuestion"
                          style="width: 220px"
                          @change="(value) => handleChangeTypeQuestion(question, value)"
                          @focus="handleElementClick(index)"
                      >
                        <el-option
                            v-for="(item, index) in typeQuestionOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                          <div style="display: flex; gap: 0 20px; height: 100%">
                            <span style="display: flex; padding: 5px"><el-image :src="item.icon"></el-image></span>
                            <span style="font-weight: 600">{{ item.label }}</span>
                          </div>
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>

                </el-row>
              </div>

              <div class="element_footer">
              <span style="cursor: pointer" @click="handleCloneQuestion(index)">
                <i class="el-icon-copy-document"/>
              </span>

                <span style="cursor: pointer" v-if="defaultDataForm.questionResponseList.length > 1"
                      @click="handleRemoveQuestion(index)">
                  <i class="el-icon-delete"/>
                </span>

                <div class="wrap_require">
                  <span class="label_require">Bắt buộc</span>
                  <el-switch v-model="question.obligatory"/>
                </div>
              </div>
            </div>

            <div class="scroll_tasks" ref="scrollTasks" v-if="defaultDataForm.questionResponseList.length > 0">
              <el-tooltip placement="right">
                <div slot="content">Thêm câu hỏi</div>
                <span class="btn_scroll_tasks" @click="handleAddNewQuestion(currentQuestionIndex)">
                <i class="el-icon-circle-plus-outline"/>
              </span>
              </el-tooltip>
            </div>
          </section>

          <!--    Phần các nút tác vụ chung cho phiếu    -->
          <section>
            <div class="wrap_button_tasks">

              <!--      Thêm câu hỏi mới vào cuối phiếu      -->
              <el-tooltip placement="top">
                <div slot="content">Thêm câu hỏi</div>
                <el-button circle @click="handleAddNewQuestion(defaultDataForm.questionResponseList.length - 1)">
                  <i class="el-icon-plus"/>
                </el-button>
              </el-tooltip>
            </div>
          </section>
        </div>
      </div>
      <div slot="footer" style="display: flex; justify-content: center">
        <div class="dialog-footer">
          <el-button @click="handleClose" type="danger" icon="el-icon-circle-close">
            Hủy bỏ
          </el-button>
          <el-button type="success" @click="handleSaveForm()" icon="el-icon-circle-check" :loading="isLoading">
            Lưu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!--   Hiển thị chi tiết ảnh   -->
    <el-dialog top="40px" class="dialog_image" width="30%" :visible.sync="isDialog.dialogVisibleImage">
      <img width="100%" :src="isDialog.dialogImageUrl" alt="Ảnh phiếu">
    </el-dialog>
  </div>
</template>

<script>

import icon from "@/assets/icons";
import Vue from "vue";
import FormSystemService from "@/services/AdminService/FormSystemService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      defaultDataForm: {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      },
      typeQuestionOptions: [
        {
          icon: icon.text,
          label: "Văn bản",
          value: "Text"
        },
        {
          icon: icon.checkbox,
          label: "Hộp kiểm",
          value: "CheckBox"
        },
        {
          icon: icon.radio,
          label: "Trắc nghiệm",
          value: "Radio"
        },
        {
          icon: icon.point,
          label: "Điểm",
          value: "Point"
        },
        {
          icon: icon.rating,
          label: "Đánh giá",
          value: "Star"
        }
      ],
      currentQuestionIndex: 0,
      listImageForm: [],
      isDialog: {
        dialogVisibleImage: false,
        dialogImageUrl: "",
      },
      isLoading: false,
    }
  },

  methods: {
    setCurrentQuestionIndex(index) {
      this.currentQuestionIndex = index;
    },

    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
      this.handleAnimationButtonAddByIndex(this.currentQuestionIndex);
    },

    resetData() {
      this.defaultDataForm = {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      }
      this.currentQuestionIndex = 0;
      this.resetSurveyImageForm();
    },

    resetSurveyImageForm() {
      this.listImageForm = [];
      this.$refs.uploadImageSurveyForm.clearFiles();
    },

    handleFocusAddOptions(valueArray, refName) {
      const option = {
        value: `Tuỳ chọn`
      }

      valueArray.push(option);

      this.$refs[refName][0].blur();
    },

    handleRemoveOptions(valueArray, index) {
      valueArray.splice(index, 1);
    },

    handleCloneQuestion(index) {
      const elementClone = this.defaultDataForm.questionResponseList[index];
      const newElement = {
        questionText: elementClone.questionText,
        valueQuestion: elementClone.valueQuestion,
        valueQuestionArray: [],
        typeQuestion: elementClone.typeQuestion,
        obligatory: elementClone.obligatory,
      };
      const indexInsert = index + 1;

      elementClone.valueQuestionArray.map(item => {
        let newValueQuestion = {
          value: item.value,
        }
        newElement.valueQuestionArray.push(newValueQuestion);
      })

      this.defaultDataForm.questionResponseList.splice(indexInsert, 0, newElement);
    },

    handleRemoveQuestion(index) {
      this.defaultDataForm.questionResponseList.splice(index, 1);

      if (this.currentQuestionIndex === index) {
        this.handleElementClick(index - 1);
      }
    },

    handleChangeTypeQuestion(question, value) {
      switch (value) {
        case "CheckBox":
        case "Radio":
          if (question.valueQuestionArray.length === 0) {
            question.valueQuestionArray.push({value: "Tuỳ chọn"})
          }
          break;
        default:
          question.valueQuestionArray = [];
      }
    },

    handleAddNewQuestion(index) {
      const question = {
        questionText: `Câu hỏi`,
        valueQuestion: "",
        valueQuestionArray: [],
        typeQuestion: "Text",
        obligatory: false,
      }
      this.defaultDataForm.questionResponseList.splice(index + 1, 0, question);
      this.handleElementClick(index + 1);
    },

    handleElementClick(index) {
      this.setCurrentQuestionIndex(index);
      this.handleAnimationButtonAddByIndex(index);
    },

    handleAnimationButtonAddByIndex(index) {
      Vue.nextTick(() => {
        // Lấy phần tử `.element_form` được nhấn
        const elementForm = this.$refs[`elementForm-${index}`][0];
        const scrollTasks = this.$refs.scrollTasks;

        if (elementForm && scrollTasks) {
          const wrapQuestion = this.$refs.wrapQuestion;
          const wrapQuestionRect = wrapQuestion.getBoundingClientRect();
          const elementFormRect = elementForm.getBoundingClientRect();

          // Tính toán vị trí top tương đối của `.element_form` so với `.wrap_question`
          const topOffset = elementFormRect.top - wrapQuestionRect.top;

          // Cập nhật vị trí `top` của `.scroll_tasks`
          scrollTasks.style.top = `${topOffset}px`;
        }
      });
    },

    handleUploadImage(file, fileList) {
      this.listImageForm = fileList;
    },

    handleRemoveImage() {
      this.defaultDataForm.image = undefined;
      this.listImageForm.splice(0, 1);
    },

    handlePictureCardPreview(file) {
      this.isDialog.dialogImageUrl = file.url;
      this.isDialog.dialogVisibleImage = true;
    },

    handleSaveForm() {
      const data = this.defaultDataForm;

      const formData = new FormData();

      formData.append("id", data.idForm)
      formData.append("title", data.title);
      formData.append("description", data.description);
      if (this.listImageForm.length > 0) {
        formData.append("imgWeb", this.listImageForm[0].raw);
      }

      data.questionResponseList.map((item, index) => {
        if (item.idQuestion) {
          formData.append(`questions[${index}].id`, item.idQuestion);
        }
        formData.append(`questions[${index}].questionText`, item.questionText);
        formData.append(`questions[${index}].typeQuestion`, item.typeQuestion);
        formData.append(`questions[${index}].obligatory`, item.obligatory);

        if (item.typeQuestion === "CheckBox" || item.typeQuestion === "Radio") {
          item.valueQuestion = item.valueQuestionArray.map(item => item.value).join(";");
          formData.append(`questions[${index}].valueQuestion`, item.valueQuestion);
        }
      });

      this.isLoading = true;
      FormSystemService.update(formData)
          .then((res) => {
            const data = res.data;

            this.$message({
              message: data.message,
              type: "success",
            });

            this.handleClose();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: err.data.message,
              type: "error",
            })
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    handleChangeInputHeader() {
      const data = this.defaultDataForm;
      if (data.title.trim() === "") {
        data.title = "Tiêu đề phiếu khảo sát";
      } else {
        data.title.trim();
      }
    },

    handleChangeTitleQuestion(index, value) {
      const field = this.defaultDataForm.questionResponseList;
      if (value === "") {
        field[index].questionText = `Câu hỏi`;
      }

      field[index].questionText.trim();
    },

    handleChangeValueQuestion(indexQuestion, indexOption, value) {
      const field = this.defaultDataForm.questionResponseList[indexQuestion];
      if (value === "") {
        field.valueQuestionArray[indexOption].value = `Tuỳ chọn`;
      }

      field.valueQuestionArray[indexOption].value.trim();
    },

    handleInitialData(id) {
      FormSystemService.getDataById(id)
          .then((res) => {
            const data = res.data.data;

            data.questionResponseList.map((item) => {
              item["valueQuestionArray"] = [];
              if (item.typeQuestion === "CheckBox" || item.typeQuestion === "Radio") {
                item["valueQuestionArray"] = item.valueQuestion.split(";").map(item => ({value: item}));
              }
            });

            this.defaultDataForm = data;
          })
          .catch((err) => {
            console.log(err);
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}


.dialog_image {
  /deep/ .el-dialog__header {
    background-color: transparent;
  }
}

.body_dialog {
  display: flex;
  justify-content: center;

  .survey_form {
    width: 50%;
  }
}

.wrap_image_form {
  height: 192px;
  position: relative;

  .image_form {
    width: 100%;
    height: 100%;

    /deep/ .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

.radius {
  border-radius: 10px;
  overflow: hidden;
}

.border {
  border: 1px solid #dadce0;
}

.element_form {
  margin-top: 10px;
  padding: 40px 34px 30px 34px;
  display: flex;
  flex-direction: column;
  gap: 24px 0;
  box-shadow: 0 0 8px 0 #DCDFE6;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: initial;
    color: #000;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }

  /deep/ textarea::placeholder,
  /deep/ input::placeholder {
    color: #7b7b7b;
  }
}

.element_question {
  display: flex;
  flex-direction: column;
  gap: 24px 0;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: 0 56px 0 14px;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }
}

.header_survey_form {
  .header_survey_title {
    /deep/ input::placeholder {
      font-size: 22px;
      font-weight: 500;
    }

    /deep/ input {
      font-size: 22px;
      font-weight: 600;
    }
  }

  .header_survey_description {

  }
}

.element_footer {
  padding: 30px 0 0 0;
  border-top: 1px solid #dadce0;
  display: flex;
  justify-content: end;
  gap: 0 34px;
  align-items: center;
  font-size: 18px;
}

.wrap_require {
  display: flex;
  align-items: center;
  gap: 0 18px;
  padding-left: 32px;
  border-left: 1px solid #dadce0;

  .label_require {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
}

.wrap_checkbox {

}

.container_checkbox {
  margin-bottom: 10px;
}

.checkbox_options {
  /deep/ input {
    width: 350px;
  }
}

.option_point {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid #b4b4b4;
  border-radius: 6px;
  color: #4e4e4e;
  font-weight: 600;
  background-color: #d6d6d6;
  cursor: not-allowed;
}

.icon_star {
  font-size: 34px;
  cursor: not-allowed;
}

.wrap_button_tasks {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 14px;
}

.wrap_question {
  position: relative;

  .scroll_tasks {
    position: absolute;
    right: -61px;
    top: 0;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    width: 50px;
    min-height: 28px;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    gap: 10px 0;
    box-shadow: 0 0 8px 0 #DCDFE6;
    border: 1px solid #dadce0;
    transition: top 0.3s ease-in;

    .btn_scroll_tasks {
      font-size: 24px;
      cursor: pointer;
    }
  }
}

.upload_image_form {
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /deep/ .el-upload {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px dashed #6f6f6f;
    z-index: 1;
    background-color: transparent;

    i {
      font-size: 20px;
    }
  }

  /deep/ .el-upload-list__item {
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .container_image {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover;
      object-position: center;
    }
  }
}

.dialog-footer {
  width: 50%;
}

.main_image {
  width: 100%;
  height: 100%;

  /deep/ .el-image__inner {
    object-fit: cover;
    object-position: center;
  }
}

/deep/ .el-dialog__headerbtn i {
  color: #fff;
}

.add_option {
  display: flex;
  gap: 0 24px;
  font-size: 15px;
  align-items: center;
  cursor: pointer;
  padding: 8px 0 0;
  width: 120px;

  &:hover {
    color: #409EFF;
  }
}
</style>